import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchInfiniteMails } from "Thunks";
import {
  openMailViewer,
  resetClientMails
  //getGalleryItemsByType,
  //setGalleryItems
} from "Actions";

import EboxComponent from "./EboxComponent";

class ClientEboxContainer extends Component {
  state = {
    status: "RECEIVED"
    //mediaType: "ALL"
  };

  componentDidMount() {
    const { fetchInfiniteMails, lrId, resetClientMails } = this.props;
    resetClientMails();
    fetchInfiniteMails({ status: this.state.status, lrId });
  }

  handleChangeStatus = (status, e) => {
    const { fetchInfiniteMails, resetClientMails, lrId } = this.props;

    this.setState({ status });

    resetClientMails();
    fetchInfiniteMails({ status, lrId });
  };

  loadMoreMails = () => {
    const { fetchInfiniteMails, lrId } = this.props;
    fetchInfiniteMails({ status: this.state.status, lrId });
  };

  /*handleChangeMediaType = mediaType => {
    const { getGalleryItemsByType, setGalleryItems, gallery } = this.props;
    setGalleryItems(gallery);
    this.setState({ mediaType });
    if (mediaType !== "ALL") {
      getGalleryItemsByType(mediaType);
    }
  };*/

  handleDisplayMail = mail => {
    const { openMailViewer } = this.props;

    openMailViewer({
      mails: [mail],
      isOpen: true,
      currentMail: mail
    });
  };

  render() {
    const { mails, hasMoreMails, fetching, fetched } = this.props;
    return (
      <EboxComponent
        mails={mails}
        hasMoreMails={hasMoreMails}
        fetching={fetching}
        fetched={fetched}
        getMailsByStatus={this.handleChangeStatus}
        loadMoreMails={this.loadMoreMails}
        status={this.state.status}
        //getGalleryItemsByType={this.handleChangeMediaType}
        //mediaType={this.state.mediaType}
        hideGallery={true}
        hideSearch={true}
        displayMailContent={this.handleDisplayMail}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  mails: state.ebox.client.items,
  //gallery: state.ebox.gallery.items,
  fetching: state.ebox.client.fetching,
  hasMoreMails: state.ebox.client.hasMoreItems,
  fetched: state.ebox.client.fetched
});

const mapDispatchToProps = dispatch => ({
  fetchInfiniteMails: type => dispatch(fetchInfiniteMails(type)),
  //  setGalleryItems: items => dispatch(setGalleryItems(items)),

  //getGalleryItemsByType: type => dispatch(getGalleryItemsByType(type)),
  resetClientMails: () => dispatch(resetClientMails()),
  openMailViewer: viewer => dispatch(openMailViewer(viewer))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientEboxContainer);



// WEBPACK FOOTER //
// ./src/components/Community/Common/Ebox/ClientEboxContainer.js